import React from 'react';
import { TreatmentAreasSection } from '../components/TreatmentAreasSection';
export function TreatmentAreasPage() {
  return <div className="pt-28" data-id="element-866">
      <TreatmentAreasSection data-id="element-867" />
    </div>;
}